<mat-card *ngIf="ready; else progressSpinner">
  <mat-card-header>
    <mat-card-title>{{pageType | capitalize }} Exercise</mat-card-title>
  </mat-card-header>
  <form class="exercise-form">
    <mat-card-content>

      <!-- Subject -->
      <mat-card-subtitle class="student">Subject</mat-card-subtitle>
      <mat-form-field class="w-auto">
        <mat-select placeholder="Subject" [formControl]="exerciseForm.get('subject')" (selectionChange)="onSelectSubject()"
                    required>
          <mat-option *ngFor="let subject of subjects" [value]="subject.name">{{ subject.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('subject'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

      <!-- Details -->
      <mat-card-subtitle class="student">Details</mat-card-subtitle>
      <mat-form-field>
        <input matInput placeholder="Title" [formControl]="exerciseForm.get('title')" required>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('title'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <textarea matInput placeholder="Description" [formControl]="exerciseForm.get('description')" required></textarea>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('description'), 'required')">This field is
          required
        </mat-error>
      </mat-form-field>

      <!-- Content -->
      <mat-card-subtitle class="student">Content</mat-card-subtitle>
      <mat-form-field>
        <textarea matInput placeholder="Intro Copy"
                  [formControl]="exerciseForm.get('introCopy')" required></textarea>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('introCopy'), 'required')" >This field is required
        </mat-error>
      </mat-form-field>

      <!-- TODO: Add to data model -->
      <mat-form-field>
        <input matInput placeholder="Intro Video Link" [formControl]="exerciseForm.get('videoLink')">
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('videoLink'), 'required')">This field is
          required
        </mat-error>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('videoLink'), 'pattern')">This field is
          invalid url
        </mat-error>
      </mat-form-field>

      <p><mat-slide-toggle (toggleChange)="toggleShowOpenAnswer()" [formControl]="exerciseForm.get('showOpenAnswerEnabled')">Show Open Answer Prompt</mat-slide-toggle></p>

      <!-- TODO: Add to data model -->
      <ng-container *ngIf="exerciseForm.get('showOpenAnswerEnabled').value === true">
        <mat-form-field>
          <textarea matInput placeholder="Open Answer Prompt" [formControl]="exerciseForm.get('openAnswerPrompt')" required></textarea>
        </mat-form-field>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('openAnswerPrompt'), 'required')">This field is
          required
        </mat-error>
      </ng-container>

      <mat-form-field>
        <textarea matInput placeholder="Complete Content"
                  [formControl]="exerciseForm.get('completeCopy')" required></textarea>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('completeCopy'), 'required')" >This field is
          required
        </mat-error>
      </mat-form-field>

      <!-- Goals -->
      <mat-card-subtitle class="student">Goals</mat-card-subtitle>
      <mat-form-field>
        <input type="number" min=0 matInput placeholder="Pacing Goal (Total Minutes)"
               [formControl]="exerciseForm.get('pacingGoal')" required/>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('pacingGoal'), 'required')" >This field is required
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <input type="number" min=0 matInput placeholder="Accuracy Goal (Percent Correct)"
               [formControl]="exerciseForm.get('accuracyGoal')" required/>
        <mat-error *ngIf="formService.controlHasError( exerciseForm.get('accuracyGoal'), 'required')" >This field is
        </mat-error>
      </mat-form-field>

    </mat-card-content>

    <!--Problems-->
    <mat-card *ngIf="pageType==='edit'">
      <mat-card-title>
        <h2>Problems</h2>
        <button mat-button color="primary" (click)="onCreateProblemForExercise()">
          Create Problem
        </button>
      </mat-card-title>
      <mat-card-content>

        <!--Problem auto complete-->
        <app-problem-auto-complete
          [problems]="problemsNotRelated"
          [hasMore]="hasMore()"
          (onProblemSelect)="addOrRemoveProblem($event, true)"
          (onLoadMore)="loadMoreProblems()"
          (onQueryChange)="handleQueryChange($event)"
        >
          <!--End Problem auto complete-->

        </app-problem-auto-complete>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let problem of exercise.problems" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>{{problem.title}}</mat-panel-title>
              <button mat-button color="primary" (click)="addOrRemoveProblem(problem, false)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-button color="primary" [routerLink]="['/problems/' + problem.id + '/edit']">Edit</button>
            </mat-expansion-panel-header>
            <mat-list>
              <ng-container *ngIf="problem.passage">
                <mat-list-item class="w-50" style="float:left">
                  <h3 mat-line>{{problem.passage}}</h3>
                  <p mat-line class="secondary-text">Passage</p>
                </mat-list-item>
              </ng-container>
            </mat-list>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
    <!--End Problems-->


    <mat-card-actions class="exercise-actions" align="end">
      <button mat-raised-button color="primary" [disabled]="!exerciseForm.valid || isSubmitting" (click)="submitForm()">
        {{buttonName}}
      </button>
    </mat-card-actions>

  </form>
</mat-card>

<ng-template #progressSpinner>
  <app-spinner></app-spinner>
</ng-template>
